var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verified_2438078 1",
    clipPath: "url(#clip0_3301_7247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5249 0.0776382L23.4781 4.21006C23.8572 4.36749 24.1042 4.73758 24.1042 5.14804V10.1716C24.1042 17.0887 19.9234 23.3108 13.5193 25.9247C13.2733 26.0251 12.9977 26.0251 12.7517 25.9247C6.34752 23.3107 2.16675 17.0886 2.16675 10.1716V5.14804C2.16675 4.73758 2.41385 4.36749 2.79293 4.21006L12.7461 0.0776382C12.9953 -0.0259048 13.2756 -0.025854 13.5249 0.0776382ZM13.1355 23.8812C18.6199 21.4649 22.073 16.0518 22.073 10.1716V5.82608L13.1355 2.11529L4.198 5.82608V10.1716C4.198 16.2111 7.79768 21.5295 13.1355 23.8812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 48098274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1914 10.3582H16.1404V8.18727C16.1404 6.42987 14.7315 5 13 5C11.2685 5 9.85965 6.42987 9.85965 8.18727V10.3582H9.8086C8.8113 10.3582 8 11.1818 8 12.194V16.5811C8 18.4661 9.51111 20 11.3682 20H14.6318C16.4891 20 18 18.4661 18 16.5811V12.194C18 11.1818 17.1887 10.3582 16.1914 10.3582ZM11.3618 8.18727C11.3618 7.27056 12.0968 6.52456 13 6.52456C13.9032 6.52456 14.6382 7.27056 14.6382 8.18727V10.3584H11.3618V8.18727ZM16.4979 16.5811C16.4979 17.6256 15.6608 18.4752 14.6318 18.4752H11.3682C10.3392 18.4752 9.50211 17.6256 9.50211 16.5811V12.194C9.50211 12.0225 9.63961 11.8829 9.8086 11.8829H16.1914C16.3604 11.8829 16.4979 12.0225 16.4979 12.194V16.5811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 14C12.4477 14 12 14.3453 12 14.7713V16.2287C12 16.6547 12.4477 17 13 17C13.5523 17 14 16.6547 14 16.2287V14.7713C14 14.3453 13.5523 14 13 14Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3301_7247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.febe69a66ed073ed5cbb3175678fb7a2.svg";
export { ForwardRef as ReactComponent };